import { Component } from "./component"
import { handleComponentError } from "../decorators/handleComponentError"
import { HeaderComponentsInterface } from "../types/headerComponents.interface"
import { HeaderInterface } from "../../realms/types/header.interface"
import { AlignmentNormalize } from "../util/AlignmentNormalize"

export class Header extends Component<
    HeaderInterface,
    HeaderComponentsInterface
> {
    private setAlignment(alignment?: string) {
        if (this.element && alignment) {
            this.element.style.justifyContent =
                AlignmentNormalize[alignment.toLowerCase()] || "normal"
        }
    }

    private setBottomBorder(bottomBorder?: string) {
        if (bottomBorder) {
            this.element?.style.setProperty("border-bottom", bottomBorder)
        }
    }

    @handleComponentError("Header")
    render() {
        this.setBackgroundColor(this.props.backgroundColor)
        this.show(this.props.isVisible)
        this.setAlignment(this.props.alignment)
        this.setBottomBorder(this.props.borderBottom)

        super.render()
    }
}
